import { ReactComponent as TwitterIcon } from "../../assets/twitter.svg";
import { ReactComponent as InstagramIcon } from "../../assets/instagram.svg";
import { ReactComponent as FacebookIcon } from "../../assets/facebook.svg";
import { ReactComponent as LinkedinIcon } from "../../assets/linkedin.svg";
import { ReactComponent as PlayStoreIcon } from "../../assets/Google_Play_Arrow_logo.svg";
import appStoreIcon from "../../assets/App_Store_(iOS).svg.png";
import { Link } from "react-router-dom";
import Logo from "../../components/logo";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  const ButtonLink = ({ href, children }) => {
    return (
      <a
        href={href}
        className="bg-white text-defaultBlack dark:bg-black dark:text-white px-4 py-3 rounded-lg flex items-center gap-2 shadow-md  active:scale-95 transition-all duration-300"
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    );
  };

  return (
    <footer className="bg-[rgb(0,73,69)] text-white py-10 bg-radial-gradient-2">
      {" "}
      {/* Increased padding */}
      <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center space-y-8 md:space-y-0">
        {" "}
        {/* Added vertical spacing */}
        {/* Logo & Description */}
        <div className="mb-8 md:mb-0">
          {" "}
          {/* Increased bottom margin */}
          <Logo />
          <p className="text-sm max-w-xs mt-4">
            {t("footerPage.overview")}
          </p>{" "}
          {/* Increased top margin */}
          {/* Social Icons */}
          <div className="flex space-x-6 mt-6">
            {" "}
            {/* Increased spacing between icons */}
            <a
              href="https://linkedin.com/company/uplus-mutual-partners/"
              target="_blank"
              rel="noreferrer"
              className="hover:text-defaultYellow duration-150"
            >
              <LinkedinIcon className="w-7 h-7" />
            </a>
            <a
              href="https://facebook.com/UplusRw"
              target="_blank"
              rel="noreferrer"
              className="hover:text-defaultYellow duration-150"
            >
              <FacebookIcon className="w-7 h-7" />
            </a>
            <a
              href="https://twitter.com/Uplusrw"
              target="_blank"
              rel="noreferrer"
              className="hover:text-defaultYellow duration-150"
            >
              <TwitterIcon className="w-7 h-7" />
            </a>
            <a
              href="https://instagram.com/Uplusrw/"
              target="_blank"
              rel="noreferrer"
              className="hover:text-defaultYellow duration-150"
            >
              <InstagramIcon className="w-7 h-7" />
            </a>
          </div>
        </div>
        {/* Links Sections */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
          {" "}
          {/* Increased gap between columns */}
          <div>
            <h4 className="font-bold mb-3">
              {t("footerPage.supportSection.title")}
            </h4>{" "}
            {/* Increased bottom margin */}
            <ul className="space-y-2 text-sm">
              {" "}
              {/* Increased spacing between list items */}
              <li>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a href="#" className="hover:text-yellow-500">
                  {t("footerPage.supportSection.links.home")}
                </a>
              </li>
              <li>
                <a href="#benefits" className="hover:text-yellow-500">
                  {t("footerPage.supportSection.links.benefits")}
                </a>
              </li>
              <li>
                <a href="#products" className="hover:text-yellow-500">
                  {t("footerPage.supportSection.links.products")}
                </a>
              </li>
              <li>
                <a href="#faqs" className="hover:text-yellow-500">
                  {t("footerPage.supportSection.links.faqs")}
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold mb-3">
              {t("footerPage.supportSection.links.help")}
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/help-center" className="hover:text-yellow-500">
                  {t("footerPage.supportSection.links.help center")}
                </Link>
              </li>
              <li>
                <Link to="/terms-conditions" className="hover:text-yellow-500">
                  {t("footerPage.supportSection.links.terms_conditions")}
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="hover:text-yellow-500">
                  {t("footerPage.supportSection.links.privacy_policy")}
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold mb-3">
              {t("footerPage.supportSection.links.products")}
            </h4>
            <ul className="space-y-2 text-sm">
              {" "}
              {/* Increased spacing between list items */}
              <li>
                <a href="#products" className="hover:text-yellow-500">
                  Social CrowdFund
                </a>
              </li>
              <li>
                <a href="#products" className="hover:text-yellow-500">
                  Ikimina
                </a>
              </li>
              <li>
                <a href="#products" className="hover:text-yellow-500">
                  U-Save
                </a>
              </li>
              {/* <li>
                <a href="#products" className="hover:text-yellow-500">
                  U-Invest
                </a>
              </li> */}
            </ul>
          </div>
        </div>
        {/* Download Buttons - Aligned Vertically */}
        <div className="hidden lg:block">
          <div className="flex flex-col space-y-4">
            <ButtonLink href="https://apple.co/2KnmQCE">
              <img src={appStoreIcon} alt="App Store" className="w-6 h-6" />
              <span>App Store</span>
            </ButtonLink>
            <ButtonLink href="http://bit.ly/uplusRW">
              <PlayStoreIcon className="w-6 h-6" />
              <span>Play Store</span>
            </ButtonLink>
          </div>
        </div>
      </div>
      <div className="w-3/4 mx-auto border-t border-white/50 mt-10"></div>{" "}
      <div className="text-center mt-6">
        <p className="text-sm">
          Uplus Mutual Partners Ltd. ©{new Date().getFullYear()}
        </p>
      </div>
    </footer>
  );
}
